import { useNavigate } from "react-router-dom"
import Footer from "../../components/molecules/footer/Footer"
import Header from "../../components/molecules/header/Header"
import ConstantesTabla from "../../utils/ConstantesTabla"
import DataTable from "react-data-table-component";
import { getNotaAclaratoria, getServiciosPrestados } from "../../components/services/ServiciosPrestadosService"
import { useEffect, useState } from "react"
import { useLocalStorage } from "../../hooks/useLocalStorage"


const HojaServiciosPrestados = () => {
    const navigate = useNavigate();
    const [user] = useLocalStorage("user", "");


      const [datosServiciosPres, setDatosServiciosPres] = useState([]);
      const [notaAclaratoria, setNotaAclaratoria] = useState("")
    
    useEffect(() => {
        getServiciosPrestados().then((data) => setDatosServiciosPres(data));
        getNotaAclaratoria().then((data) => setNotaAclaratoria(data));
    }, []);
    
    return (<>
        <Header />
        <div className="container contenedorHojaSeriviciosPrestados" role="main" data-landmark-index="4">
            <div className="hojaServicios row">
                {/*<Titulo
                    tipo={"tituloModal"}
                    titulo={"Hoja de servicios préstados"}
                />*/}
                <h2 className="tituloAccesibilidadMini">Hoja de servicios prestados</h2>

            </div>

            <div className="datosPersonalesNotas m-4">
                <div className="row"><div className="fw-bold col-1">DNI: </div> <div className="col-11">{user.niep}</div></div>
                <div className="row"><div className="fw-bold col-2">Nombre y Apellidos: </div> <div className="col-10">{user.nombreCompleto}</div></div>                
                

                <div className= "notaAclaratoria mensajeInfo fondo p-3 mt-4">
                  <p className= "fw-bold"> Nota Aclaratoria: </p>
                  <p>{notaAclaratoria}</p>  
                </div>

            </div>


            <div className="container tablacolumnasTablaServiciosPrestados card">
                                <DataTable
                                    className="table-responsive"
                                    columns={[...ConstantesTabla.columnasServiciosPrestados]}
                                    data={datosServiciosPres.CERSERPER}
                                    pagination={true}
                                    paginationComponentOptions={ConstantesTabla.paginacionOpt}
                                    noDataComponent={<span>No se encontraron servicios prestados</span>}
                                    customStyles={ConstantesTabla.customStyles}
                                    width="auto"
                                    fixedHeader

                                    subHeaderWrap={true}
                                    style={{ marginTop: "20px" }}
                                />
            </div>

            <div className="buttons gridBotones mb-2">
                <button
                    id="volver"
                    className="btnRed rounded btnCancelarDocumentacion"
                    type="button"
                    onClick={() => navigate("/home")}
                >
                    <i className="fa-solid fa-rotate-left"></i> Volver
                </button>
            </div>
        </div>
        <Footer />
    </>)
}

export default HojaServiciosPrestados